import React from "react";
import useNflTeams from "../../hooks/queryResults/nfl/useNflTeams";
import useIsLoading from "../../hooks/queryResults/useIsLoading";
import Util from "../../util/util";
import Loading from "../ui/Loading";

export default function NflGameScoringPlays({ nflGameStatsData }) {
  console.log("nflGameStatsData", nflGameStatsData);
  const { nflTeamsData, nflTeamsQuery } = useNflTeams();

  const isLoading = useIsLoading(nflGameStatsData, nflTeamsData, nflTeamsQuery);
  if (isLoading) return <Loading />;

  const nflTeams = {};

  const getNflTeamById = (teamId) => {
    if (!nflTeams.hasOwnProperty(teamId)) {
      const abbrevs = Object.keys(nflTeamsData.nflTeams);
      for (const abbr of abbrevs) {
        const team = nflTeamsData.nflTeams[abbr];
        if (team.id === teamId) {
          nflTeams[teamId] = team;
          break;
        }
      }
    }

    return nflTeams[teamId];
  };

  return (
    <table>
      <thead>
        <tr>
          <th>Quarter</th>
          <th>Team</th>
          <th>Type</th>
          <th>Description</th>
          <th>Score</th>
          <th>Special</th>
        </tr>
      </thead>
      <tbody>
        {nflGameStatsData.nflGameStats.scoringPlays.map((play, i) => {
          const {
            clock,
            description,
            drive,
            nflTeam: nflTeamId,
            quarter,
            score,
            scoreType,
          } = play;

          const nflTeam = getNflTeamById(nflTeamId);

          const special = [];

          if (play.special) {
            if (play.special.defensiveTd) special.push("DEF");
            if (play.special.fumbleTd) special.push("FUM");
            if (play.special.twoPointSuccess) special.push("SUCCESS");
            if (play.special.twoPointAttempt) special.push("2PT");
          }

          return (
            <tr key={i}>
              <td>
                {Util.toOrdinal(quarter)}
                <br />
                {clock}
              </td>
              <td>{nflTeam.abbr}</td>
              <td>{scoreType}</td>
              <td className={"left"}>
                {description}
                <br />
                <span
                  style={{
                    fontStyle: "italic",
                    fontSize: "0.66rem",
                    opacity: 0.7,
                  }}
                >
                  {drive}
                </span>
              </td>
              <td>
                {nflGameStatsData.nflGameStats.away.abbr} {score}{" "}
                {nflGameStatsData.nflGameStats.home.abbr}
              </td>
              <td style={{ whiteSpace: "nowrap" }}>{special.join(",")}</td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
}
